// /* global IS_PRODUCTION */

import React from 'react';
import { render } from 'react-dom';

import BaseModule from '../../../javascripts/helpers/baseModule';

import App from './components/App.jsx';

export default class Location extends BaseModule {
  constructor(element) {
    super(element, 'location');
  }

  // triggered once in BaseModule
  init() {
    const config = JSON.parse(this.elements.self.dataset.jsModuleConfig);
    render(<App data={config} />, this.elements.self);
  }
}
